import React, {useState, useEffect}					from 'react';

import Input										from '../ressources/components/Input';
import DocumentItem									from '../ressources/components/Document';
import Load											from '../ressources/components/Load/Load';
import Modal										from '../ressources/components/Modal';

import {useAppSelector, useAppDispatch}				from '../app/hooks';
import {pushUpload, closeUpload,
	setUploadPercent}								from '../redux/documents/documents';
import {UserNotNull}								from '../redux/user/interface';
import {Document} 									from '../redux/documents/interface';

import {ft_genNotification, ft_pushNotification}	from '../ressources/functions/notification';
import {ft_getDocumentCreator}						from '../ressources/functions/document';
import {ft_formatUserName}							from '../ressources/functions/format';

import img_upload									from '../ressources/images/icon/upload.svg';
import img_trash									from '../ressources/images/icon/trash.svg';

import LANGUAGE										from '../ressources/language';
import * as API										from '../ressources/API';

import './Users.css';

interface Props {
	editData?: UserNotNull,
	documents?: File[],
	setDocument?: (docuements: File[]) => void
}

function UsersDocuments(props: Props) {
	const dispatch = useAppDispatch();
	const user = useAppSelector(state => state.user.data);
	const users = useAppSelector(state => state.companyUsers.data);
	const documentsUpload = useAppSelector(state => state.documents.uploadDocument);
	const lang = useAppSelector(state => state.settings.lang);
	const idNotification = useAppSelector(state => state.notifications.lastId);

	const [deviceDocuments, set_deviceDocuments] = useState<Document[]>([]);
	const [modal, set_modal] = useState<null | {url: string, document: Document}>(null);
	const [load, set_load] = useState(false);

	const TEXTE = LANGUAGE(lang);

	useEffect(() => {
		if (!props.editData)
			return;

		set_load(true);
		set_deviceDocuments([]);
		getUserDocument();
	}, [props.editData?._id]);

	function getUserDocument() {
		if (!props.editData)
			return;

		API.getUsersDocuments(props.editData._id, user)
		.then((response) => {
			set_load(false);
			if (response && response.status)
				set_deviceDocuments(response.data);
		});
	}

	function uploadFile(file: FileList | null) {
		if (!file || !file[0] || (!props.editData && !props.setDocument))
			return;

		if (props.setDocument && props.documents)
			props.setDocument([...props.documents, file[0]]);

		if (!props.editData)
			return;

		let error = null;

		if (file[0].size > 2097152)
			error = TEXTE.global.fileToBig;

		const index = documentsUpload.length;

		const dispatchData = {
			index,
			dispatch,
			function: setUploadPercent
		};

		const uploadFileData = {
			percent:  error || 0,
			filename: file[0].name,
			size:     file[0].size,
			id:       props.editData._id
		};

		dispatch(pushUpload(uploadFileData));

		if (!error) {
			API.uploadUsersDocument(props.editData._id, file[0], user, dispatchData)
			.then((response) => {
				if (!response || !response.status)
					return dispatch(setUploadPercent({index, percent: `error: ${response?.error || ''}`}));

				const notification = ft_genNotification(TEXTE, 'fileDownloadDone', img_upload, ft_formatUserName(props.editData));

				ft_pushNotification(dispatch, idNotification, notification);
				getUserDocument();
			});
		}
	}

	function renderDocuments() {
		const render: React.ReactElement[] = [];

		deviceDocuments.forEach((document, i) => {
			const onClickDelete = () => {
				if (!props.editData)
					return;

				API.deleteUsersDocument(props.editData._id, document, user)
				.then((response) => {
					const notification = ft_genNotification(TEXTE, (!response || !response.status) ? 'error' : 'editSuccess', img_trash, response.error, (!response || !response.status) ? 'error' : 'success');

					ft_pushNotification(dispatch, idNotification, notification);
					getUserDocument();
				});
			};

			render.push(
				<DocumentItem
					key={i}
					size={document.size}
					filename={document.name}
					onClickDelete={onClickDelete}
					creator={ft_getDocumentCreator(document, users)}
					onClick={async () => {
						if (!props.editData)
							return;

						const url = await API.downloadUsersDocument(props.editData._id, document, user, true);

						set_modal({url: url as string, document});
					}}
					onClickDownload={() => props.editData && API.downloadUsersDocument(props.editData._id, document, user)}
				/>
			);
		});

		return render;
	}

	function renderUploadDocuments() {
		const render: React.ReactElement[] = [];

		documentsUpload.forEach((uploadData, index) => {
			if (uploadData.isClose || uploadData.id !== props.editData?._id || uploadData.percent as number === 100)
				return;
			render.push(
				<DocumentItem
					size={uploadData.size}
					percent={uploadData.percent}
					filename={uploadData.filename}
					onClickDelete={() => dispatch(closeUpload(index))}
				/>
			);
		});

		props.documents?.forEach((file, index) => {
			render.push(
				<DocumentItem
					size={file.size}
					filename={file.name}
					percent={file.size > 2097152 ? TEXTE.global.fileToBig : ' '}
					onClickDelete={() => {
						if (!props.documents || !props.setDocument)
							return;
						const copy: File[] = [...props.documents];

						copy.splice(index, 1);
						props.setDocument(copy);
					}}
				/>
			);
		});

		return render;
	}

	return (
		<div className={'deviceDocumentsContainer'}>
			{props.editData &&
				<span className={'deviceDocumentsTitle'}>{TEXTE.users.userDocuments}</span>
			}
			{renderDocuments()}

			{load && <Load center />}
			{(!load && props.editData && deviceDocuments.length === 0) && <DocumentItem documentType={'users'} />}

			<span className={'deviceDocumentsTitle'}>{TEXTE.devices.downloadDocuments}</span>
			<Input
				type={'file'}
				onChangeFile={uploadFile}
				fileInputText={TEXTE.devices.deviceDocumentRules}
				accept={'gif,.jpg,.jpeg,.tiff,.png,.webp,.bmp,.pdf'}
			/>
			{renderUploadDocuments()}

			{modal &&
				<Modal
					fullWidth
					onClose={() => set_modal(null)}
					confirmButtonText={TEXTE.global.download}
					confirmButton={() => props.editData && API.downloadUsersDocument(props.editData._id, modal.document, user)}
				>
					<embed src={modal.url} style={{width: '100%', height: '90vh'}} />
				</Modal>
			}
		</div>
	);
}

export default UsersDocuments;
